import { useEffect, useRef, useState } from 'react';

export function useScrollReveal(threshold = 0.12, delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let timer: ReturnType<typeof setTimeout>;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          timer = setTimeout(() => setVisible(true), delay);
          observer.unobserve(el);
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [threshold, delay]);

  return { ref, visible };
}

type AnimVariant = 'up' | 'down' | 'fromLeft' | 'fromRight' | 'fade' | 'scale';

export function animStyle(
  visible: boolean,
  variant: AnimVariant = 'up',
  delay = 0,
  duration = 700
): React.CSSProperties {
  const transforms: Record<AnimVariant, string> = {
    up: 'translateY(28px)',
    down: 'translateY(-28px)',
    fromLeft: 'translateX(-32px)',
    fromRight: 'translateX(32px)',
    fade: 'none',
    scale: 'scale(0.94)',
  };

  return {
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0) translateX(0) scale(1)' : transforms[variant],
    transition: `opacity ${duration}ms ease-out ${delay}ms, transform ${duration}ms ease-out ${delay}ms`,
  };
}
